import { render, staticRenderFns } from "./AcceptTerms.vue?vue&type=template&id=776db6c5"
import script from "./AcceptTerms.vue?vue&type=script&lang=js"
export * from "./AcceptTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports